'use client'

import { Spacer as SpaceOG, TamaguiComponent, styled } from 'tamagui'

export const Spacer = styled(SpaceOG as any, {
  name: 'Spacer',
}) as TamaguiComponent
